import type { UseMutationOptions, UseMutationResult } from "@tanstack/react-query";
import { useMutation } from "@tanstack/react-query";
import client from "@/api/client/axios";
import type { ResponseConfig } from "@/api/client/axios";
import type { CancelMultiRequestMutationResponse, CancelMultiRequestPathParams, CancelMultiRequestQueryParams, CancelMultiRequest400, CancelMultiRequest404, CancelMultiRequest500 } from "../types/CancelMultiRequest";

/**
 * @summary Отмена мультизаявки пользователя
 * @link /api/multirequests/:requestId
 */

export function useCancelMultiRequest <TData = CancelMultiRequestMutationResponse, TError = CancelMultiRequest400 | CancelMultiRequest404 | CancelMultiRequest500>(requestId: CancelMultiRequestPathParams["requestId"], params: CancelMultiRequestQueryParams, options: {
          mutation?: UseMutationOptions<ResponseConfig<TData>, TError, void>,
          client?: Partial<Parameters<typeof client<TData, TError, void>>[0]>,
      } = {}): UseMutationResult<ResponseConfig<TData>, TError, void> {
  const { mutation: mutationOptions, client: clientOptions = {} } = options ?? {};

  return useMutation<ResponseConfig<TData>, TError, void>({
    mutationFn: () => {
      
      return client<TData, TError, void>({
        method: "delete",
        url: `/api/multirequests/${requestId}`,
        
        params,
        
        ...clientOptions
      });
    },
    ...mutationOptions
  });
};
